import { typeBuilder } from 'base/shared/TypeHelper';

export default typeBuilder(['SET_DEVICE']);
